export default __webpack_public_path__ + "static/media/quiz_practice.f8b56ffe.png";